import {Component, Input, OnInit} from '@angular/core';
import {CustomBlock} from 'fuse-core/components/collection/custom-blocks/custom-block.model';
import {DomSanitizer} from '@angular/platform-browser';
import {BlockHandlerService} from 'fuse-core/components/collection/custom-blocks/block-handler.service';

@Component({
  selector: 'app-half-width-cta',
  templateUrl: './half-width-cta.component.html',
  styleUrls: ['./half-width-cta.component.scss']
})
export class HalfWidthCtaComponent {

    @Input() block: CustomBlock;

    constructor(
        public blockHandler: BlockHandlerService
    ) {}


}
